import { Text } from '@/components'

interface ServiceCardProps {
  title: string
  description: string
  linkText: string
  linkHref?: string
  icon: React.ReactNode
  containerClassName?: string
  onClick?: () => void
}

export function ServiceCard({
  title,
  description,
  linkText,
  linkHref,
  icon,
  containerClassName = 'bg-white',
  onClick,
}: ServiceCardProps) {
  const handleClick = () => {
    if (onClick) {
      onClick()
    } else if (linkHref) {
      window.open(linkHref, '_blank')
    }
  }

  return (
    <div
      className={`relative rounded-3xl py-8 px-6 cursor-pointer hover:shadow-card transition-shadow group ${containerClassName}`}
      onClick={handleClick}
    >
      <div className='flex items-center gap-4'>
        <div className='flex-shrink-0 w-6 h-6 flex items-center justify-center'>
          {icon}
        </div>

        <div className='flex-1 min-w-0 flex flex-col gap-4'>
          <h3 className='text-heading-5 text-cencert-header-blue'>{title}</h3>
          <Text variant='small' color='text-gray'>
            {description}
          </Text>
          <p className='text-body-sm font-medium text-cencert-blue leading-6 tracking-wide group-hover:underline'>
            {linkText}
          </p>
        </div>
      </div>
    </div>
  )
}
